import { TRANSLATION_FILES } from '../constants/translation';

export const isVietnamCountryCode = (countryCode) => {
  if (typeof countryCode !== 'string') {
    return false;
  }
  return countryCode.toLowerCase() === 'vn';
};

// CPI-1230 (D1): the unit's `size` is Vietnam's NSA (Net Saleable Area) and its `landArea` is
// Vietnam's NFA (Net Floor Area). Every arm that is not Vietnam is byte-identical to before.
export const getAreaLabel = (t, countryCode, options = {}) => {
  const isVietnam = isVietnamCountryCode(countryCode);
  const { short = false, lower = false } = options;

  if (short) {
    return t(isVietnam ? 'Net Saleable' : 'Build Up', { ns: TRANSLATION_FILES.screens });
  }

  if (lower) {
    return t(isVietnam ? 'unit net saleable area' : 'unit build up area', { ns: TRANSLATION_FILES.screens });
  }

  return t(isVietnam ? 'Net saleable area' : 'Build Up Area', { ns: TRANSLATION_FILES.translation });
};

export const getMissingAreaLabel = (t, countryCode) => t(
  isVietnamCountryCode(countryCode) ? 'No net saleable area available' : 'No build up area available',
  { ns: TRANSLATION_FILES.translation },
);

export const getAreaModelLabel = (t, countryCode) => t(
  isVietnamCountryCode(countryCode) ? 'NSA · Net Saleable Area' : 'Build Up Area',
  { ns: TRANSLATION_FILES.screens },
);

// The companion of getAreaModelLabel for the unit's `landArea` row.
export const getLandAreaModelLabel = (t, countryCode) => t(
  isVietnamCountryCode(countryCode) ? 'NFA · Net Floor Area' : 'Land Area',
  { ns: TRANSLATION_FILES.screens },
);

// The unit list's sort menu names the same `size` column, so its wording follows the reversal.
export const getAreaSortLabels = countryCode => (
  isVietnamCountryCode(countryCode)
    ? { ascending: 'Net Saleable Ascending', descending: 'Net Saleable Descending' }
    : { ascending: 'Build Up Ascending', descending: 'Build Up Descending' }
);

// CPI-1230 (D-D6): the standalone unit create / edit form labels the same column "Size", so it
// cannot reuse getAreaModelLabel without moving a Malaysian label.
export const getUnitFormAreaLabel = (t, countryCode) => (
  isVietnamCountryCode(countryCode)
    ? getAreaModelLabel(t, countryCode)
    : t('Size', { ns: TRANSLATION_FILES.screens })
);



// WEBPACK FOOTER //
// ./src/utils/areaLabel.js